import { LangUtil } from '../../common/utils/lang-util';
import { getAuthUser, getSpeechLangVoiceMap } from '../store/general/selectors';
import { getState } from '../store';
import { TVoicesMap } from '../types/common';
import { getSelectedTargetCaption } from '../store/current-video/selectors';

export class SpeechVoiceManager {

  private static voices: TVoicesMap;

  public static init() {
    const timer = setInterval(() => {
      const voices = speechSynthesis.getVoices();
      if (voices?.length) {
        clearInterval(timer);
        const voicesMap: TVoicesMap = {};
        voices.forEach(voice => {
            const langCode = LangUtil.checkLangCode(voice.lang);
            if (!voicesMap[langCode]) {
              voicesMap[langCode] = [];
            }
            voicesMap[langCode].push(voice);
        });
        for (let lang in voicesMap) { // save langs with choice
          if (voicesMap[lang].length < 2) {
            delete voicesMap[lang];
          }
        }
        this.voices = voicesMap;
      }
    }, 1000);
  }

  public static getVoices(): TVoicesMap {
    return this.voices;
  }

  public static getVoiceListByLang(lang: string): SpeechSynthesisVoice[] {
    return this.voices[lang] ? this.voices[lang] : [];
  }

  public static getLangsWithMulitpleVoices(): string[] {
    return Object.keys(this.voices)
  }

}

export class SpeechVoiceUserSelector {

  public static getVoice(langCode: string): SpeechSynthesisVoice | undefined {
    let result: SpeechSynthesisVoice | undefined

    const voiceList = SpeechVoiceManager.getVoiceListByLang(langCode)
    if (!voiceList?.length) return undefined;

    const langVoiceUserMap = getSpeechLangVoiceMap(getState());
    const userVoiceURI = langVoiceUserMap[langCode]
    if (userVoiceURI) {
      result = voiceList.find(v => v.voiceURI === userVoiceURI)
    }
    if (!result) {
      result = voiceList.find(v => v.name.toLocaleLowerCase().indexOf('google') >= 0)
    }
    if (!result) {
      result = voiceList[0];
    }
    return result;
  }

  public static getUserLangsForSelect(): string[] {
    const state = getState();
    const langSet: Set<string> = new Set<string>();
    const targetLang = getSelectedTargetCaption(state)?.code
    if (targetLang)
      langSet.add(targetLang)
    const translLangs = getAuthUser(state)?.translateLangs?.map(l => l.code)
    if (translLangs)
      translLangs.forEach(l => langSet.add(l))
    const langsWithVoices = SpeechVoiceManager.getLangsWithMulitpleVoices()
    return Array.from(langSet).filter(lang => langsWithVoices.includes(lang))
  }
}

SpeechVoiceManager.init();
